import React from 'react';
import { FaMoon, FaSun } from "react-icons/fa";
import { useTheaterMode } from '../context/TheaterModeContext';
import { useRouter } from 'next/router';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // Import Tippy.js CSS

const TheaterModeToggle = () => {
  const { theaterMode, toggleTheaterMode } = useTheaterMode();
  const router = useRouter();
  const siteVersion = router.pathname.substring(0, 3);

  return (
    <Tippy  className="customTooltip" content={siteVersion === '/fr' ? (theaterMode ? "Passer en mode clair" : "Passer en mode sombre") : (theaterMode ? "Switch to light mode" : "Switch to dark mode")} placement='left'>
      <button onClick={toggleTheaterMode} className={theaterMode ? "theaterButton" : "theaterButton-light"}>
        {theaterMode ? <FaSun /> : <FaMoon /> }
      </button>
    </Tippy>
  );
};

export default TheaterModeToggle;
